import React from 'react';
import { HomePage } from './pages/HomePage';
import { RecordsPage } from './pages/RecordsPage';
import { AdvertisingPage } from './pages/AdvertisingPage';
import { SaintLuciaPage } from './pages/SaintLuciaPage';
import { BarndormatoryPage } from './pages/BarndormatoryPage';
import { FilmsPage } from './pages/FilmsPage';
import { ApparelsPage } from './pages/ApparelsPage';
import { HonorableMusicPage } from './pages/HonorableMusicPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/records') {
    return <RecordsPage data-id="element-0" />;
  }
  if (path === '/advertising') {
    return <AdvertisingPage data-id="element-1" />;
  }
  if (path === '/saint-lucia') {
    return <SaintLuciaPage data-id="element-2" />;
  }
  if (path === '/barndormatory') {
    return <BarndormatoryPage data-id="element-3" />;
  }
  if (path === '/films') {
    return <FilmsPage data-id="element-4" />;
  }
  if (path === '/apparels') {
    return <ApparelsPage data-id="element-5" />;
  }
  if (path === '/honorable-music') {
    return <HonorableMusicPage data-id="element-6" />;
  }
  return <HomePage data-id="element-7" />;
}